import { MonoTypeOperatorFunction, distinctUntilChanged } from 'rxjs';
import * as equal from 'fast-deep-equal';

export const distinctUntilObjectChanged = <T extends object>(): MonoTypeOperatorFunction<T> =>
  distinctUntilChanged((prev, curr) => equal(prev, curr));
